import type Trail from '@alltrails/types/Trail';
import type { PageUITrailResultSection } from './pageUI';

/**
 * The Trail that trail cards need, built from a `trail-result` section. Fills only what the cards read.
 */
const trailFromPageUISection = (section: PageUITrailResultSection): Trail => {
  return {
    id: section.trailId,
    name: section.name,
    // Cards add the `trail/` themselves, so the section's Algolia-style slug would link to /trail/trail/...
    slug: section.slug.replace(/^trail\//, ''),
    area: { name: section.locationLabel },
    avgRating: section.avgRating,
    defaultActivityStats: { difficulty: section.difficultyRating, rating: section.avgRating },
    trailCounts: { reviewCount: section.numReviews ?? 0 },
    trailGeoStats: {
      durationMinutes: section.durationMinutes?.toString(),
      length: section.length
    }
  };
};

export default trailFromPageUISection;
